import { PaneContentType, RootState } from "shared/types";

export const selectStage = () => (state: RootState) => state.classroom.client.stage;

// We check for the existence of `pane` in the following selectors to avoid
// a mysterious bug where `pane` is sometimes null.
export const selectIsDefaultStage = () => (state: RootState) =>
  state.classroom.client.stage.panes.length === 8 &&
  state.classroom.client.stage.panes.every(
    (pane) => pane && pane.content_type === PaneContentType.Empty,
  );

export const selectPollSessionIdsOnStage = () => (state: RootState) =>
  state.classroom.client.stage.panes
    .filter((pane) => pane && pane.content_type === PaneContentType.PollSession)
    .map((pane) => pane.content_id);

export const selectFirstActivePollSessionPane = () => (state: RootState) => {
  return state.classroom.client.stage.panes.find(
    (pane) => pane && pane.content_type === PaneContentType.PollSession,
  );
};
